export default {
  urlsWithoutInterceptors: ['/general/logging/client', '/schedule/stats/group/'],
  systemTitle: {
    fullName: 'ИС Посещаемость',
    shortName: 'Посещаемость'
  },
  routing: {
    authPage: {
      path: '/auth',
      name: 'Авторизация в системе'
    },
    homePage: {
      path: '/main-page',
      name: 'О проекте'
    }
  },
  mobileWidth: 768,
  defaultWidth: 1000
}
